var _path, _path2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCountryBi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 20,
    viewBox: "0 0 28 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2858_8508)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 2C0 0.895431 0.895431 0 2 0H26C27.1046 0 28 0.895431 28 2V18C28 19.1046 27.1046 20 26 20H2C0.895431 20 0 19.1046 0 18V2Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2858_8508",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 28,
    height: 20
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 2C0 0.895431 0.895431 0 2 0H26C27.1046 0 28 0.895431 28 2V18C28 19.1046 27.1046 20 26 20H2C0.895431 20 0 19.1046 0 18V2Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2858_8508)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 20,
    fill: "#E4233B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0L12 10L0 20V0Z",
    fill: "#34CD4E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28 0L16 10L28 20V0Z",
    fill: "#34CD4E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.9621 6.39369C16.1563 5.7311 15.1246 5.33328 14 5.33328C12.8753 5.33328 11.8436 5.7311 11.0379 6.39369L-1.2825 -1.9165L-2.77368 0.294263L9.54573 8.60381C9.4077 9.04464 9.3333 9.5136 9.3333 9.99994C9.3333 10.4863 9.4077 10.9552 9.54573 11.3961L-2.77368 19.7056L-1.2825 21.9164L11.0379 13.6062C11.8436 14.2688 12.8753 14.6666 14 14.6666C15.1246 14.6666 16.1563 14.2688 16.9621 13.6062L29.2824 21.9164L30.7736 19.7056L18.4542 11.3961C18.5922 10.9552 18.6666 10.4863 18.6666 9.99994C18.6666 9.5136 18.5922 9.04464 18.4542 8.60381L30.7736 0.294263L29.2824 -1.9165L16.9621 6.39369Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9999 8.66673L13.0571 8.94287L13.3333 8.00006L13.0571 7.05725L13.9999 7.33339L14.9427 7.05725L14.6666 8.00006L14.9427 8.94287L13.9999 8.66673ZM11.9999 12L11.0571 12.2762L11.3333 11.3334L11.0571 10.3906L11.9999 10.6667L12.9427 10.3906L12.6666 11.3334L12.9427 12.2762L11.9999 12ZM15.0571 12.2762L15.9999 12L16.9427 12.2762L16.6666 11.3334L16.9427 10.3906L15.9999 10.6667L15.0571 10.3906L15.3333 11.3334L15.0571 12.2762Z",
    fill: "#DF2239"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2858_8508"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 2C0 0.895431 0.895431 0 2 0H26C27.1046 0 28 0.895431 28 2V18C28 19.1046 27.1046 20 26 20H2C0.895431 20 0 19.1046 0 18V2Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCountryBi);
export default __webpack_public_path__ + "static/media/Country=BI.91fa34d82e42fb86ed9050812b2de368.svg";
export { ForwardRef as ReactComponent };